import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as FileSaver from 'file-saver';
import { PdfViewerComponent, PdfViewerModule } from 'ng2-pdf-viewer';
import { FooterComponent } from 'src/app/shared/portal-layout/footer/footer.component';
import { DetailHeaderComponent } from '../detail-header/detail-header.component';

import { ContentDocumentLink } from 'src/app/models/content-document-link.model';
import { FileAPI } from 'src/app/core/services/attachment';
import { Order } from 'src/app/models/order.model';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatProgressSpinnerModule, DetailHeaderComponent, PdfViewerModule, FooterComponent],
})
export class OrderDetailComponent implements OnChanges, OnInit {
  private cdr = inject(ChangeDetectorRef);

  @Input() order: Order;

  @Input() serviceOrderForm: ContentDocumentLink;

  @Input() formAPIData: FileAPI;

  @Input() areOrdersLoading: boolean;

  @Input() isFileLoading: boolean;

  @Input() browserSize: string;

  @Output() openContactInformationModal = new EventEmitter<{
    user: User;
    title: string;
  }>();

  @ViewChild(PdfViewerComponent, { static: true })
  fileComponent: PdfViewerComponent;

  isFileLoaded = false;

  isPdf = false;

  isOrderAvailable = false;

  hasErrors = false;

  canEmbedFile: boolean;

  fileUrl: any = '';

  currentFilePage = 1;

  totalFilePages: number;

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(): void {
    this.initialize();
  }

  initialize(): void {
    if (this.order?.Id) {
      this.isOrderAvailable = true;
    } else {
      this.isOrderAvailable = false;
    }

    if (this.formAPIData?.url) {
      this.fileUrl = this.formAPIData.url;
      if (
        this.serviceOrderForm.ContentDocument &&
        this.serviceOrderForm.ContentDocument.FileExtension === 'pdf'
      ) {
        this.isPdf = true;
      }
      if (this.fileUrl !== '') {
        this.currentFilePage = 1;
        this.canEmbedFile = true;
      } else {
        this.onFileError();
      }
      this.isFileLoaded = true;
    }
    this.cdr.detectChanges();
  }

  downloadFile(): void {
    const newBlob = new Blob([this.formAPIData.binaryData], {
      type: `application/${this.serviceOrderForm.ContentDocument.FileExtension}`,
    });
    FileSaver.saveAs(
      newBlob,
      `${this.serviceOrderForm.ContentDocument.Title}.${this.serviceOrderForm.ContentDocument.FileExtension}`,
    );
  }

  onFileError(): void {
    this.isFileLoading = false;
    this.canEmbedFile = false;
    this.isFileLoaded = true;
    this.cdr.detectChanges();
  }

  afterFileLoadComplete(fileData: any): void {
    this.totalFilePages = fileData.numPages;
    this.isFileLoaded = true;
    this.cdr.detectChanges();
  }

  viewContactInformation(user: User, title: string): void {
    this.openContactInformationModal.emit({ user, title });
  }
}
